__turbopack_context__.v({
  "GC": "styles-module-scss-module__-grPEq__GC",
  "SC": "styles-module-scss-module__-grPEq__SC",
  "badgeSlotTop": "styles-module-scss-module__-grPEq__badgeSlotTop",
  "badgeSlotTop3D": "styles-module-scss-module__-grPEq__badgeSlotTop3D",
  "balls": "styles-module-scss-module__-grPEq__balls",
  "currency": "styles-module-scss-module__-grPEq__currency",
  "icon": "styles-module-scss-module__-grPEq__icon",
  "icon-GC": "styles-module-scss-module__-grPEq__icon-GC",
  "icon-SC": "styles-module-scss-module__-grPEq__icon-SC",
  "img": "styles-module-scss-module__-grPEq__img",
  "img3D": "styles-module-scss-module__-grPEq__img3D",
  "infoRow": "styles-module-scss-module__-grPEq__infoRow",
  "infoRowItem": "styles-module-scss-module__-grPEq__infoRowItem",
  "moreInfoBtn": "styles-module-scss-module__-grPEq__moreInfoBtn",
  "moreInfoBtnIcon": "styles-module-scss-module__-grPEq__moreInfoBtnIcon",
  "tagItem": "styles-module-scss-module__-grPEq__tagItem",
  "tagJackpot": "styles-module-scss-module__-grPEq__tagJackpot",
  "tagJackpotLarge": "styles-module-scss-module__-grPEq__tagJackpotLarge",
  "tile": "styles-module-scss-module__-grPEq__tile",
  "tileBottom": "styles-module-scss-module__-grPEq__tileBottom",
  "tileTop": "styles-module-scss-module__-grPEq__tileTop",
  "tileTop3D": "styles-module-scss-module__-grPEq__tileTop3D",
  "title": "styles-module-scss-module__-grPEq__title",
});
